import { Box, Container, Stack, Typography } from '@mui/material';
import React, { memo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import PositiveButton from 'components/cmn/PositiveButton';
import { IContent } from 'interface/project/projectInfo';
import { useProject } from 'hooks/useProject';

interface IClassificationGuideCompleteProps {
  title: string;
  projectDetailInfo?: IContent;
}

function ClassificationGuideComplete({ title, projectDetailInfo }: IClassificationGuideCompleteProps): JSX.Element {
  const [searchParams] = useSearchParams();
  const { urlProjectId, urlPartCode } = useProject();

  useEffect(() => {
    const callbackUrl = searchParams.get('callbackUrl');
    const userId = searchParams.get('userId');

    if (callbackUrl && urlProjectId && urlPartCode) {
      const backendUrl = process.env.REACT_APP_URL || '';
      const hardcodedId = 'b64a9678-10d7-4624-9392-cdd7b0c8cb8b';
      const downloadPdfUrl = `${backendUrl}/api/pdf/result/${urlProjectId}/${hardcodedId}/${urlPartCode}`;

      // callbackUrl에 downloadPdf, partCode, userId 파라미터 추가
      const separator = callbackUrl.includes('?') ? '&' : '?';
      const finalCallbackUrl = `${callbackUrl}${separator}downloadPdf=${encodeURIComponent(downloadPdfUrl)}&partCode=${urlPartCode}${userId ? `&userId=${userId}` : ''}`;

      console.log('finalCallbackUrl:', finalCallbackUrl);

      // 1초 딜레이 후 callbackUrl로 리다이렉트
      const timer = setTimeout(() => {
        window.location.href = finalCallbackUrl;
      }, 1000);

      return () => {
        clearTimeout(timer);
      };
    }
    return undefined;
  }, [searchParams, urlProjectId, urlPartCode]);

  const handleNext = () => {
    console.log('진단 종료');
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        py: 4,
      }}
    >
      <Box
        sx={{
          p: 4,
          width: '100%',
          maxWidth: { xs: '100%', md: '1536px' },
          height: { xs: 'auto', md: '864px' },
        }}
      >
        <Container maxWidth="xl" sx={{ height: '100%', width: '100%' }}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{ height: '100%', width: '100%', flex: 1, minHeight: 0 }}
          >
            <Container
              maxWidth="md"
              sx={{
                p: 0,
                height: 'calc(100% - 84px)',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mt: 5,
              }}
            >
              <Typography
                typography="s20w400"
                variant="p"
                gutterBottom
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  lineHeight: { xs: 1.4, sm: 1.6 },
                  wordBreak: 'keep-all',
                  textAlign: 'left',
                  whiteSpace: 'pre-line',
                  width: '100%',
                  fontSize: { xs: '16px', sm: '22px' },
                  fontWeight: 'bold',
                }}
              >
                {(projectDetailInfo?.guide?.complete || '설문이 완료되었습니다.\n응답해 주셔서 감사합니다.')
                  .split('\\n')
                  .map(line => (
                    <React.Fragment key={line.trim()}>
                      {line}
                      <br />
                      <br />
                    </React.Fragment>
                  ))}
              </Typography>
            </Container>
          </Stack>
        </Container>
      </Box>
      {/* 하단 버튼 영역 높이만큼 여백 추가 (버튼 높이 52px + 패딩 32px = 약 84px) */}
      <Box sx={{ height: { xs: 84, sm: 84 } }} />
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          bgcolor: 'background.paper',
          boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
          py: 2,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <PositiveButton
          variant="contained"
          onClick={handleNext}
          sx={{ width: { xs: 130 }, height: 52, typography: 's14w500', display: 'none' }}
          title={title}
        />
      </Box>
    </Box>
  );
}

export default memo(ClassificationGuideComplete);
